// EGKCRM-514 PR-2: Vue.prototype.$can helper
// 任何元件可透過 this.$can(resource, action) 判斷當前使用者是否有權限
import store from '@/store'

export default {
  install (Vue) {
    Vue.prototype.$can = function (resource, action) {
      return store.getters['permission/can'](resource, action)
    }
    Vue.prototype.$permissionScope = function (resource, action = 'view') {
      return store.getters['permission/getScope'](resource, action)
    }
  }
}
